export default __webpack_public_path__ + "c7c72d8b6feb875e1fdebfc9132aa416.png";